import Input from "../../../common/Input";

const EmailInfo = ({
  formik,
  isEdit,
  handleEditIconClick,
  handleBlur,
  editingField,
  isDisabled,
}) => {
  const { values, handleChange, touched, errors, setFieldTouched } = formik;
  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">Email</h2>
      <div className="grid grid-cols-12 gap-[8px]">
        <div className="col-span-6">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Doctor Email"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="emailInfo.doctorEmail"
            id="emailInfo.doctorEmail"
            value={values?.emailInfo?.doctorEmail}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("emailInfo.doctorEmail", true, false); // Mark the field as touched
            }}
            isError={
              touched?.emailInfo?.doctorEmail &&
              Boolean(errors?.emailInfo?.doctorEmail)
            }
            errorMessage={errors?.emailInfo?.doctorEmail}
            disabled={isDisabled && editingField !== "emailInfo.doctorEmail"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("emailInfo.doctorEmail") : ""
            }
            onEditClick={() => handleEditIconClick("emailInfo.doctorEmail")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-6">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Clinic Email"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="emailInfo.clinicEmail"
            id="emailInfo.clinicEmail"
            value={values?.emailInfo?.clinicEmail}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("emailInfo.clinicEmail", true, false); // Mark the field as touched
            }}
            isError={
              touched?.emailInfo?.clinicEmail &&
              Boolean(errors?.emailInfo?.clinicEmail)
            }
            errorMessage={errors?.emailInfo?.clinicEmail}
            disabled={isDisabled && editingField !== "emailInfo.clinicEmail"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("emailInfo.clinicEmail") : ""
            }
            onEditClick={() => handleEditIconClick("emailInfo.clinicEmail")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
      </div>
    </div>
  );
};
export default EmailInfo;
